// extracted by mini-css-extract-plugin
module.exports = {"accordion":"styles-module--accordion--2wZWX","mask":"styles-module--mask--33EAM","pagePadding":"styles-module--pagePadding--3HV7D","list":"styles-module--list--3zZdb"};